import './index.less';
import { useTranslation } from '@/hooks/useTranslation';

export default function () {
  const $ = useTranslation();
  return (
    <div className='xitger-error-content'>
      <img
        src='https://web-prod-static-cdn.x-peng.com/sso/static/404.0a674b47.png'
        width='240'
        height='200'
      />
      <p className='xitger-error-tips'>{$('NotFound')}</p>
    </div>
  );
}
